import { Injectable } from '@angular/core';
import { APP_CONSTANTS } from '../../constants/app.constants';

@Injectable({
  providedIn: 'root'
})
export class TokenStorageService {

  setToken(token: string): void {
    localStorage.setItem(APP_CONSTANTS.TOKEN_KEY, token);
  }

  getToken(): string | null {
    return localStorage.getItem(APP_CONSTANTS.TOKEN_KEY);
  }

  removeToken(): void {
    localStorage.removeItem(APP_CONSTANTS.TOKEN_KEY);
  }

  setUser(user: unknown): void {
    localStorage.setItem(APP_CONSTANTS.USER_KEY, JSON.stringify(user));
  }

  getUser<T>(): T | null {
    const userData = localStorage.getItem(APP_CONSTANTS.USER_KEY);
    return userData ? JSON.parse(userData) : null;
  }

  removeUser(): void {
    localStorage.removeItem(APP_CONSTANTS.USER_KEY);
  }

  clear(): void {
    this.removeToken();
    this.removeUser();
  }
}
